import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid,
  Box,
  Chip,
  Divider,
  Stack,
} from "@mui/material";
import moment from "moment";
import { ExamProps } from "./Exam";
import CardHeader from "./layouts/CardHeader";
import CountChips from "./layouts/CountChips";
import InfoBox from "./layouts/InfoBox";
import CardFooter from "./layouts/CardFooter";
// export interface ExamProps {
//   data: any;
//   onclick?: () => void;
//   child?: any;
//   selected?:any
// }
function Goal({
  data,
  onclick,
  tempSelected,
  setCardsSelected,
  cardsSelected,child
}: any) {
  const formatDate = (date: moment.MomentInput) =>
    moment(date).format("Do MMM YYYY, hh:mm A");

  const tempS = data.id === tempSelected?.data.id;
  console.log(cardsSelected, "cardsSelected");
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: tempS ? 4 : "none",
        transform: tempS ? "scale(1.01)" : "none",
        border: tempS ? "2px dashed #519C66" : "2px dashed #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: 4,
          transform: "scale(1.01)",
          border: "2px dashed #519C66",
        },
        pointerEvents: tempS ? "none" : "auto",
      }}
      onClick={onclick}
    >
      <CardContent>
        <CardHeader
          name={data.name}
            onClick={onclick}
            selected={child?true:false}
          description={data.description}
          id={data.id}
          status={data.status}
          is_active={data.is_active}
        />
        {/* Stats Row */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={6} sm={4} md={2}>
            <CountChips
              label="Sections"
              onClick={
                tempS && cardsSelected.goal
                  ? () => {
                      if (cardsSelected.section) {
                        setCardsSelected({
                          section: false,
                          unit: false,
                          topic: false,
                          subtopic: false,
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          section: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.section : false}
              value={data.total_sections}
              color="#f3e8ff"
              text="#7c3aed"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <CountChips
              onClick={
                tempS && cardsSelected.goal && cardsSelected.section
                  ? () => {
                      if (cardsSelected.unit) {
                        setCardsSelected({
                          unit: false,
                          topic: false,
                          subtopic: false,
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          unit: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.unit : false}
              label="Units"
              value={data.total_units}
              color="#e0f2fe"
              text="#0284c7"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <CountChips
              onClick={
                tempS &&
                cardsSelected.goal &&
                cardsSelected.section &&
                cardsSelected.unit
                  ? () => {
                      if (cardsSelected.topic) {
                        setCardsSelected({
                          topic: false,
                          subtopic: false,
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          topic: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.topic : false}
              label="Topics"
              value={data.total_topics}
              color="#dcfce7"
              text="#16a34a"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <CountChips
              onClick={
                tempS &&
                cardsSelected.goal &&
                cardsSelected.section &&
                cardsSelected.unit &&
                cardsSelected.topic
                  ? () => {
                      if (cardsSelected.subtopic) {
                        setCardsSelected({
                          subtopic: false,
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          subtopic: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.subtopic : false}
              label="Subtopics"
              value={data.total_subtopics}
              color="#eef2ff"
              text="#4f46e5"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <CountChips
              label="Clusters"
              onClick={
                tempS &&
                cardsSelected.goal &&
                cardsSelected.section &&
                cardsSelected.unit &&
                cardsSelected.topic &&
                cardsSelected.subtopic
                  ? () => {
                      if (cardsSelected.cluster) {
                        setCardsSelected({
                          cluster: false,
                          question: false,
                        });
                      } else {
                        setCardsSelected({
                          cluster: true,
                          question: true,
                        });
                      }
                    }
                  : undefined
              }
              selected={tempS ? cardsSelected.cluster : false}
              value={data.total_clusters}
              color="#fee2e2"
              text="#dc2626"
            />
          </Grid>
          <Grid item xs={6} sm={4} md={2}>
            <CountChips
              selected={tempS ? cardsSelected.question : false}
              label="Questions"
              value={data.total_questions}
              color="#fef3c7"
              text="#d97706"
            />
          </Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Basic Info */}
        <Grid container spacing={2} mb={2}>
          <Grid item  xs={12} sm={6} md={6}>
            <EllipsisText label="Path Order:" value={data.path_order} /><EllipsisText
              label="Quiz Level:"
              value={data.quiz_available_from_level ?? "-"}
            />
          </Grid>
           <Grid item  xs={12} sm={6} md={6}>
           
            <EllipsisText
              label="Minimum Depth:"
              value={data.minimum_depth ?? "-"}
            />
            <EllipsisText
              label="Maximum Depth:"
              value={data.maximum_depth ?? "-"}
            />
            
          </Grid>
        </Grid>
        <Divider sx={{ mb: 2 }} />
        {/* Sections */}
        <Grid container spacing={2}mb="10px">
          <Grid item xs={12} sm={6} md={6}>
            <InfoBox
              title="Notification Dates"
              lines={[
                `Notification: ${
                  data.notification_date
                    ? formatDate(data.notification_date)
                    : "-"
                }`,
                `Tentative: ${
                  data.tentative_notification_date
                    ? formatDate(data.tentative_notification_date)
                    : "-"
                }`,
              ]}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <InfoBox
              title="Publish Dates"
              lines={[
                `Publish: ${
                  data.publish_date ? formatDate(data.publish_date) : "-"
                }`,
                `Tentative: ${
                  data.tentative_publish_date
                    ? formatDate(data.tentative_publish_date)
                    : "-"
                }`,
              ]}
            />
          </Grid>
        </Grid>{" "}
        <CardFooter
          internal_remark={data.internal_remark}
          created_at={data.created_at}
          created_by_id={data.created_by_id}
          modified_at={data.modified_at}
          modified_by_id={data.modified_by_id}
        />
      </CardContent> {child}
    </Card>
  );
}

// Reusable EllipsisText component
export function EllipsisText({ label, value }: { label: string; value: any }) {
  return (
    <Typography
      variant="body2"
      noWrap
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      <strong>{label}</strong> {value}
    </Typography>
  );
}

export default Goal;
